module.exports = __webpack_public_path__ + "body4-bg.png?1f46aeeb663de11c491f847596892af7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/body4-bg.png
// module id = 175
// module chunks = 0